import React from "react";

// Per Michael's Phase 1 v3 spec (message overrides demo where they diverge):
//   LEGACY   → grey       (#E7EAEF bg / #5B6672 text)
//   OPEN     → light navy (#F1F4FB bg / #1B3D7A text)
//   ACTIVE   → light green(#EBF3EE bg / #1F6F47 text)
//   ON HOLD  → light yel  (#FEF6E1 bg / #B58611 text)
//   INVOICED → SOLID navy (#1B3D7A bg / white text)
//   COMPLETE → SOLID deep green (#14563A bg / white text)
const STYLES = {
    open:     "km-chip km-chip-navy",
    active:   "km-chip km-chip-green",
    complete: "km-chip km-chip-green-solid",
    on_hold:  "km-chip km-chip-yellow",
    invoiced: "km-chip km-chip-navy-solid",
    legacy:   "km-chip km-chip-grey",
    // roles
    admin:    "km-chip km-chip-red",
    office:   "km-chip km-chip-navy",
    staff:    "km-chip km-chip-grey",
    // rate scope reuse
    field:    "km-chip km-chip-green",
    all:      "km-chip km-chip-yellow",
};

export function StatusBadge({ status, className = "" }) {
    const cls = STYLES[status] || "km-chip km-chip-grey";
    return (
        <span className={`${cls} ${className}`}>
            {String(status || "").replace(/_/g, " ")}
        </span>
    );
}
